import React from 'react';
import { useQuery } from '@tanstack/react-query';
import Axios from 'axios';
import cn from '@/utils/cn';
import I18n from '@/modules/i18n';
import { shared_question_answer_path } from '@/modules/routes';
import { IQuestionAnswer } from '@/components/staffer/Grading/types';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import GridQuestionTable, { GridData } from './GridQuestionTable';

const GridQuestionStudentAnswer = ({ questionAnswer }: { questionAnswer: IQuestionAnswer }) => {
  const programId = useGradingStore(state => state.programId);
  const isUnanswered = questionAnswer?.answer_updated_at == null;

  const {
    data: gridData,
    isLoading: loading,
    error,
  } = useQuery<GridData>({
    enabled: !!questionAnswer?.id,
    queryFn: async () => {
      const response = await Axios.get(shared_question_answer_path(questionAnswer.id), {
        params: { locale: I18n.locale, program_id: programId },
      });
      return response.data;
    },
    queryKey: ['gridData', questionAnswer?.id, programId],
  });

  const renderMessage = (content, isError = false) => (
    <div className={cn('tw-p-5 tw-text-center', { 'tw-text-red': isError })}>
      {content}
    </div>
  );

  const renderContent = () => {
    if (!questionAnswer?.id) return 'No answer provided.';
    if (loading) return renderMessage('Loading grid...');
    if (error) return renderMessage('Failed to load grid data', true);
    if (isUnanswered) return 'No answer provided.';

    return <GridQuestionTable gridData={gridData} />;
  };

  return (
    <div
      className={cn(
        { 'notebook-grid-wrapper tw-block tw-overflow-x-auto': loading || error || !isUnanswered },
      )}
    >
      {renderContent()}
    </div>
  );
};

export default GridQuestionStudentAnswer;
